import { render, staticRenderFns } from "./ClientPersonalData.vue?vue&type=template&id=2f7f15e3&scoped=true"
import script from "./ClientPersonalData.vue?vue&type=script&lang=js"
export * from "./ClientPersonalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7f15e3",
  null
  
)

export default component.exports